import { create } from 'zustand';
import { User } from '../types';

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  setUser: (user: User, token: string) => void;
  logout: () => void;
  setLoading: (loading: boolean) => void;
  updateUser: (user: User) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: (() => {
    try {
      const stored = localStorage.getItem('lanre_savage_user');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  })(),
  token: localStorage.getItem('lanre_savage_token'),
  isAuthenticated: !!localStorage.getItem('lanre_savage_token'),
  isLoading: false,

  setUser: (user, token) => {
    localStorage.setItem('lanre_savage_token', token);
    localStorage.setItem('lanre_savage_user', JSON.stringify(user));
    set({ user, token, isAuthenticated: true });
  },

  logout: () => {
    localStorage.removeItem('lanre_savage_token');
    localStorage.removeItem('lanre_savage_user');
    set({ user: null, token: null, isAuthenticated: false });
  },

  setLoading: (loading) => set({ isLoading: loading }),

  updateUser: (user) => {
    localStorage.setItem('lanre_savage_user', JSON.stringify(user));
    set({ user });
  },
}));